// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__XMItC","actionsCol":"EnrolledClinics_actionsCol__TZW4H"};